import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import Home from 'assets/home.svg'
import HomeLightBlue from 'assets/home-light-blue.svg'

export default function PrivateIcon(props) {
    const { isControl, contextStyles } = props
    return (
        <div className={cn(styles.iconComp, styles.fontIconComp, contextStyles)}>
            <img src={isControl ? HomeLightBlue : Home} alt="home" />
        </div>
    )
}
